export default __webpack_public_path__ + "static/2-e20e20976576f1a4de2cc1857d8b5ece.jpg";